import { EventEmitter } from "@angular/core";

interface ValueChangeEvent {
  oldValue: any;
  newValue: any;
}

export class ProcessingOrderUiState {
  private _storage = localStorage;
  private _storageKey = "ProcessingOrderUiState";

  private _anlageGroup = "";
  public anlageGroupChange = new EventEmitter<ValueChangeEvent>();
  public get anlageGroup() {
    return this._anlageGroup;
  }
  public set anlageGroup(value: string) {
    if (this._anlageGroup === value) {
      return;
    }
    const prev = this.anlageGroup;
    this._anlageGroup = value;
    this._saveState();
    this.anlageGroupChange.emit({ oldValue: prev, newValue: value });
  }

  public constructor() {
    const json = JSON.parse(this._storage.getItem(this._storageKey));
    Object.assign(this, json);
  }

  private _saveState() {
    const json = JSON.stringify({
      _anlageGroup: this._anlageGroup,
    });
    this._storage.setItem(this._storageKey, json);
  }
}
